import { TRACK } from '@disco/constants/ItemTypes'
import { isAggregatedSearchTrack } from '@disco/utils/tracks'
import { getDiscoverDragAndDropTrackProperties } from './discover-page'

const filterDraggedItemProperties = (draggedItem: any) => {
  if (draggedItem?.playlistId) {
    const { playlist, playlistBusiness, playlistId } = draggedItem
    return {
      playlist,
      playlistId,
      playlistBusiness,
    }
  } else if (draggedItem?.catalogId) {
    const { catalogName, catalogId, catalogBusiness } = draggedItem
    return {
      catalogName,
      catalogId,
      catalogBusiness,
    }
  }
}

export const getMixpanelDragAndDropProps = (draggedItem, type: string) => {
  const isAggregatedSearch = isAggregatedSearchTrack(draggedItem.track)
  const selectedItems = draggedItem?.selectedItems || []
  const track = draggedItem?.track

  const trackIds = selectedItems
    .filter(item => item.type === TRACK)
    .map(item => item.id)

  const itemCatalogs = selectedItems
    .map(
      item =>
        item?.origin?.source_library?.id || item?.origin?.primary_library?.id,
    )
    .filter(Boolean)

  const itemBusinesses = selectedItems
    .map(item => item?.origin?.business?.name)
    .filter(Boolean)

  const isDiscoverItem = draggedItem?.id?.includes('discover')
  if (isDiscoverItem) {
    const filteredProperties = filterDraggedItemProperties(draggedItem)
    return getDiscoverDragAndDropTrackProperties(
      {
        trackId: track?.id,
        ...filteredProperties,
        context: draggedItem?.context,
      },
      type,
    )
  }

  const mixpanelProperties = {
    'Track ID': trackIds?.length ? trackIds : track?.id,
    'Playlist ID': draggedItem?.sourcePlaylistId,
    Catalog: itemCatalogs?.length
      ? itemCatalogs
      : track?.origin?.source_library?.id || track?.origin?.primary_library?.id,
    'Catalog Business': itemBusinesses?.length
      ? itemBusinesses
      : track?.origin?.business?.name,
    Location: draggedItem?.location || 'Explorer',
    Source: draggedItem?.source || draggedItem?.sourceGroupType,
    'Group Type': draggedItem?.sourceGroupType,
    'Group ID': draggedItem?.sourceGroupId,
    Context: isAggregatedSearch ? 'Aggregated search' : draggedItem?.context,
    Search: isAggregatedSearch ? 'Aggregated search' : draggedItem?.searchType,
    Type: type,
  }

  return mixpanelProperties
}
